module.exports = __webpack_public_path__ + "img/Icon-KeyboardArrow-Up-Dark.b6a2a10e.svg";